import { put, select } from 'core/middlewares/utilities';
import { app, cart, combo, shippingModel } from 'core/use-cases';

import { bffRequest } from './helpers';
import {
  validateShippingModel,
  user as userSelectors,
  shippingModel as shippingModelSelectors,
} from '../../helpers';

import type { RequestAction } from './@types';
import type { User } from 'core/domains';
import type { RootState } from 'core/store';

/**
 * Middleware responsible for the effects of BFF actions.
 *
 */
export function* effects(action: RequestAction) {
  switch (action.type) {
    case combo.actions.comboPost.request.type:
    case cart.actions.itemAddFetch.request.type: {
      const isShippingModel: boolean = yield validateShippingModel();
      const shippingModelHasBeenSelected: RootState['cart']['shippingModelHasBeenSelected'] =
        yield select((rootState: RootState) => rootState.cart.shippingModelHasBeenSelected);

      if (isShippingModel && !shippingModelHasBeenSelected) {
        let defaultShippingModel = {} as User['data']['shippingModel']['default'];
        let availableDeliveries = {} as User['data']['shippingModel']['availables'];

        const isToggleShippingModel: boolean =
          yield shippingModelSelectors.getShippingModelToggle();

        if (isToggleShippingModel) {
          defaultShippingModel = yield shippingModelSelectors.getDefaultShippingModel();
          availableDeliveries = yield shippingModelSelectors.getAvailablesDeliveries();
        } else {
          defaultShippingModel = yield userSelectors.getDefaultShippingModel();
          availableDeliveries = yield userSelectors.getAvailablesDeliveries();
        }

        if (availableDeliveries.length) {
          yield put(app.actions.toggleShipping(true));

          return;
        }

        yield put(cart.actions.setDefaultShippingModel(defaultShippingModel));

        if (isToggleShippingModel) {
          yield put(
            shippingModel.actions.currentDeliveryModeFetch.request({
              businessModelCode: defaultShippingModel?.code,
              distributionCenterCode: defaultShippingModel.delivery.distributionCenterCode,
              isWithdrawal: false,
              address: defaultShippingModel.delivery.address,
            }),
          );
          return;
        }

        yield put(
          cart.actions.cartSetShippingModelFetch.request({
            businessModelCode: defaultShippingModel?.code,
            changeDeliveryMode: true,
            distributionCenterCode: defaultShippingModel?.delivery?.distributionCenterCode,
            iswithdrawal: false,
          }),
        );
        return;
      }

      yield bffRequest(action);

      return;
    }

    default:
      yield bffRequest(action);
  }
}
